module.exports = __webpack_public_path__ + "images/stickers/taco-robot@2x.e1ac5a98088053a8b1ae.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-robot@2x.png
// module id = 28nG
// module chunks = 2